import { Navigate } from 'react-router-dom';
import { GoogleAuthProvider } from 'firebase/auth';
import { auth } from 'firebaseui';
import { useAuth } from '../../hooks';
import { StyledFirebaseAuth } from '../StyledFirebaseAuth';
import styles from './LoginComponent.module.css';

// Configure FirebaseUI.
const uiConfig: auth.Config = {
  // Popup sign in flow rather than redirect flow.
  signInFlow: 'popup',
  // We will display Google and Facebook as auth providers.
  signInOptions: [GoogleAuthProvider.PROVIDER_ID],
  callbacks: {
    // Avoid redirects after sign-in.
    signInSuccessWithAuthResult: () => false,
  },
};

export const LoginComponent = () => {
  const { user } = useAuth();

  if (!user) {
    return (
      <div className={styles.container}>
        <p style={{ textAlign: 'center' }}>Sign-in with Google:</p>
        <StyledFirebaseAuth uiCallback={(ui: any) => ui.disableAutoSignIn()} uiConfig={uiConfig} />
      </div>
    );
  }

  const redirectAfterLogin = globalThis && (globalThis as any).firstUrl ? (globalThis as any).firstUrl : '/';

  return <Navigate to={redirectAfterLogin}></Navigate>;
};
